import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import EditAraiMfgQuoation from "./AraiMfgQuotation/EditAraiMfgQuotation";
import PumpDomesticQuotationConversion from "./ConversionsFiles/PumpDomesticConversion";
import PumpInternationalQuotationConversion from "./ConversionsFiles/PumpInternationalConversion";
import AraiMfgDomesticQuotationConversion from "./ConversionsFiles/AraiDomesticConversion";
import AraiMfgQuoationConversion from "./ConversionsFiles/AraiInternationalConversion";

const SEtoSQConversion = () => {
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setEnquiryData(response.data);
      setProductType(response.data.enquirytype);
      setProductCategory(response.data.enquirycategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <PumpDomesticQuotationConversion enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <PumpInternationalQuotationConversion enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <AraiMfgDomesticQuotationConversion enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <AraiMfgQuoationConversion enquiryData={enquiryData} />;
      }
    } else {
      return null;
    }
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Sales Enquiry to Sales Quotation Conversion</h6>
          <Link to={`/quotationIndexTable/1`}>
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Quotation Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={productType ? true : false}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Quotation Category:</Form.Label>
                <Form.Select
                  disabled={!productType ? true : false || productCategory ? true : false}
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};

export default SEtoSQConversion;
